import type { ResolverEnum } from '@e-socna/data-layer';

export enum ResolutionErrorCode {
  CycleDetected = 'CYCLE_DETECTED',
  MaxDepthExceeded = 'MAX_DEPTH_EXCEEDED',
}

export interface ResolutionCycleError {
  readonly code: ResolutionErrorCode.CycleDetected;
  readonly message: string;
  readonly cycleVariables: readonly ResolverEnum[];
}

export interface ResolutionMaxDepthError {
  readonly code: ResolutionErrorCode.MaxDepthExceeded;
  readonly message: string;
  readonly depth: number;
  readonly remainingVariables: readonly string[];
}

export type ResolutionError = ResolutionCycleError | ResolutionMaxDepthError;
